import {capturePointer} from './pointerCapture.js';

// Eight equal direction sectors around a small neutral center. Coordinates are
// relative to the pad radius, so dragging and resizing the pad do not change it.
export function dpadDirections(x, y) {
    if (!Number.isFinite(x) || !Number.isFinite(y) || Math.hypot(x, y) < .22) return [];
    const diagonal = Math.tan(Math.PI / 8);
    const directions = [];
    if (Math.abs(x) >= Math.abs(y) * diagonal) directions.push(x < 0 ? 'left' : 'right');
    if (Math.abs(y) >= Math.abs(x) * diagonal) directions.push(y < 0 ? 'up' : 'down');
    return directions;
}

export class TouchDpad {
    constructor(surface, onChange, enabled = () => true) {
        this.surface = surface;
        this.onChange = onChange;
        this.enabled = enabled;
        this.pointer = null;
        this.directions = [];
        surface.style.touchAction = 'none';
        surface.addEventListener('pointerdown', event => {
            if (event.button !== 0 || this.pointer !== null || !this.enabled()) return;
            event.preventDefault(); event.stopPropagation();
            this.pointer = event.pointerId;
            capturePointer(surface, event.pointerId);
            this.move(event);
        });
        surface.addEventListener('pointermove', event => this.move(event));
        for (const type of ['pointerup', 'pointercancel', 'lostpointercapture']) {
            surface.addEventListener(type, event => {
                if (event.pointerId !== this.pointer) return;
                event.preventDefault(); event.stopPropagation();
                this.reset();
            });
        }
        // These compatibility touch events must not reach the game's canvas /
        // editor listeners while the thumb slides, including outside the pad.
        for (const type of ['touchstart', 'touchmove', 'touchend', 'touchcancel', 'contextmenu']) {
            surface.addEventListener(type, event => { event.preventDefault(); event.stopPropagation(); }, {passive: false});
        }
    }
    move(event) {
        if (event.pointerId !== this.pointer) return;
        event.preventDefault(); event.stopPropagation();
        if (!this.enabled()) { this.reset(); return; }
        const box = this.surface.getBoundingClientRect();
        if (!box.width || !box.height) { this.reset(); return; }
        this.setDirections(dpadDirections((event.clientX - box.left - box.width / 2) / (box.width / 2),
            (event.clientY - box.top - box.height / 2) / (box.height / 2)));
    }
    setDirections(directions) {
        if (directions.join() === this.directions.join()) return;
        this.directions = directions;
        this.onChange(directions);
    }
    reset() {
        const pointer = this.pointer;
        this.pointer = null;
        this.setDirections([]);
        if (pointer !== null && this.surface.hasPointerCapture(pointer)) this.surface.releasePointerCapture(pointer);
    }
}
